import styled from 'styled-components'
import { Typography, Input, Button } from 'antd'

const { Text } = Typography

export const WarningContainer = styled.div`
    padding: 15px;
    background-color: #fff2f0;
    border: 1px solid #ffccc7;
    border-radius: 6px;
    margin: 20px 0;
`

export const WarningText = styled(Text)`
    color: #ff4d4f;
    font-weight: bold;
`

export const ReviewContainer = styled.div`
    width: 100%;
`

export const UserDetailsSection = styled.div`
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    background: #FAFBFC;
    padding: 10px 0;
    gap: 10px;
`

export const SectionDivider = styled.hr`
    height: 1px;
    width: 95%;
    background-color: rgba(0, 0, 0, 0.2);
    border: none;
`

export const PrescriptionDivider = styled.hr`
    margin: 30px 50px;
    border-top-color: #FAFBFC;
`

export const AuthSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`

export const DEADisclaimer = styled.div`
    width: 70%;
    margin: 10px;
    background: #FAFBFC;
    padding: 10px 20px;
`

export const PinInput = styled(Input)`
    && {
        width: 75px;
        margin-left: 10px;
    }
`

export const TFASection = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
`

export const TFAControlsRow = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
`

export const TFACodeInput = styled(Input)`
    && {
        width: 75px;
        margin: 0 10px;
    }
`

export const TabsContainer = styled.div`
    padding: 0 50px;
`

export const DuoButton = styled(Button)`
    &.ant-btn-primary {
        background-color: #7BAD7E;
        border-color: #7BAD7E;

        &:hover,
        &:focus {
            background-color: #7BAD7E;
            border-color: #7BAD7E;
        }
    }
`
